const SERVICE_STATUS = {
  added: 'added',
  removed: 'removed',
  pending: 'pending',
};

export default SERVICE_STATUS;
